// extracted by mini-css-extract-plugin
export default {"bold-children":"bold-children","not-bold":"not-bold","remove-border-bottom":"remove-border-bottom","alternative-subtitle-text":"alternative-subtitle-text"};